module.exports = __webpack_public_path__ + "fonts/SuisseIntl-MediumItalic.c75e406.woff2";